const LikeIcon = () => (
  <svg aria-label="Like" fill="currentColor" height="24" role="img" viewBox="0 0 24 24" width="24">
    <title>Like</title>
    <path d="M16.792 3.904A4.989 4.989 0 0 1 21.5 9.122c0 3.072-2.652 4.959-5.197 7.222-2.512 2.243-3.865 3.469-4.303 3.752-.477-.309-2.143-1.823-4.303-3.752C5.141 14.072 2.5 12.167 2.5 9.122a4.989 4.989 0 0 1 4.708-5.218 4.21 4.21 0 0 1 3.675 1.941c.84 1.175.98 1.763 1.12 1.763s.278-.588 1.11-1.766a4.17 4.17 0 0 1 3.679-1.938m0-2a6.04 6.04 0 0 0-4.797 2.127 6.052 6.052 0 0 0-4.787-2.127A6.985 6.985 0 0 0 .5 9.122c0 3.61 2.55 5.827 5.015 7.97.283.246.569.494.853.747l1.027.918a44.998 44.998 0 0 0 3.518 3.018 2 2 0 0 0 2.174 0 45.263 45.263 0 0 0 3.626-3.115l.922-.824c.293-.26.59-.519.885-.774 2.334-2.025 4.98-4.32 4.98-7.94a6.985 6.985 0 0 0-6.708-7.218Z"></path>
  </svg>
)

const CommentIcon = () => (
  <svg aria-label="Comment" fill="currentColor" height="24" role="img" viewBox="0 0 24 24" width="24">
    <title>Comment</title>
    <path
      d="M20.656 17.008a9.993 9.993 0 1 0-3.59 3.615L22 22Z"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
    ></path>
  </svg>
)

const ShareIcon = () => (
  <svg aria-label="Share Post" fill="currentColor" height="24" role="img" viewBox="0 0 24 24" width="24">
    <title>Share Post</title>
    <line
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
      x1="22"
      x2="9.218"
      y1="3"
      y2="10.083"
    ></line>
    <polygon
      fill="none"
      points="11.698 20.334 22 3.001 2 3.001 9.218 10.084 11.698 20.334"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
    ></polygon>
  </svg>
)

const BookmarkIcon = () => (
  <svg aria-label="Save" fill="currentColor" height="24" role="img" viewBox="0 0 24 24" width="24">
    <title>Save</title>
    <polygon
      fill="none"
      points="20 21 12 13.44 4 21 4 3 20 3 20 21"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    ></polygon>
  </svg>
)

const MusicIcon = () => (
  <svg aria-label="Music" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 8C1 4.13401 4.13401 1 8 1H19C22.866 1 26 4.13401 26 8V12C26 13.6569 24.6569 15 23 15H22C18.134 15 15 18.134 15 22V23C15 24.6569 13.6569 26 12 26H8C4.13401 26 1 22.866 1 19V8Z"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M30 19.5C27.5 20 22.4 21 22 21V26C20.8954 26 20 26.8954 20 28C20 29.1046 20.8954 30 22 30C23.1046 30 24 29.1046 24 28V23.625L28 22.875V25C26.8954 25 26 25.8954 26 27C26 28.1046 26.8954 29 28 29C29.1046 29 30 28.1046 30 27V19.5Z"
      fill="white"
    />
  </svg>
)

const CheckIcon = () => (
  <svg aria-label="Check" width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.64165 6.4103L4.79174 5.57504C4.68428 5.46758 4.54986 5.41385 4.38847 5.41385C4.22709 5.41385 4.08797 5.47247 3.97114 5.5897C3.86368 5.69716 3.80995 5.83393 3.80995 6C3.80995 6.16607 3.86368 6.30284 3.97114 6.4103L5.23135 7.67052C5.34858 7.78774 5.48534 7.84636 5.64165 7.84636C5.79796 7.84636 5.93472 7.78774 6.05195 7.67052L8.54307 5.1794C8.6603 5.06217 8.71637 4.9254 8.71129 4.76909C8.70621 4.61279 8.65014 4.47602 8.54307 4.35879C8.42584 4.24156 8.28653 4.1806 8.12515 4.17592C7.96376 4.17123 7.82465 4.2273 7.70781 4.34414L5.64165 6.4103ZM4.00044 11.7149L3.15053 10.2789L1.53863 9.92718C1.3921 9.89787 1.27487 9.82206 1.18694 9.69975C1.09902 9.57744 1.06483 9.44321 1.08437 9.29707L1.24556 7.64121L0.146536 6.38099C0.0488454 6.27353 0 6.14654 0 6C0 5.85346 0.0488454 5.72647 0.146536 5.61901L1.24556 4.35879L1.08437 2.70293C1.06483 2.5564 1.09902 2.42197 1.18694 2.29966C1.27487 2.17735 1.3921 2.10174 1.53863 2.07283L3.15053 1.72114L4.00044 0.285082C4.0786 0.158084 4.18606 0.0725066 4.32282 0.0283503C4.45959 -0.0158059 4.59636 -0.00838144 4.73312 0.0506239L6.2571 0.695384L7.78108 0.0506239C7.91785 -0.00799068 8.05462 -0.0154152 8.19138 0.0283503C8.32815 0.0721159 8.43561 0.157693 8.51376 0.285082L9.36367 1.72114L10.9756 2.07283C11.1221 2.10213 11.2393 2.17794 11.3273 2.30025C11.4152 2.42256 11.4494 2.55679 11.4298 2.70293L11.2686 4.35879L12.3677 5.61901C12.4654 5.72647 12.5142 5.85346 12.5142 6C12.5142 6.14654 12.4654 6.27353 12.3677 6.38099L11.2686 7.64121L11.4298 9.29707C11.4494 9.4436 11.4152 9.57803 11.3273 9.70034C11.2393 9.82265 11.1221 9.89826 10.9756 9.92718L9.36367 10.2789L8.51376 11.7149C8.43561 11.8419 8.32815 11.9275 8.19138 11.9717C8.05462 12.0158 7.91785 12.0084 7.78108 11.9494L6.2571 11.3046L4.73312 11.9494C4.59636 12.008 4.45959 12.0154 4.32282 11.9717C4.18606 11.9279 4.0786 11.8423 4.00044 11.7149Z"
      fill="white"
    />
  </svg>
)

export { LikeIcon, CommentIcon, ShareIcon, BookmarkIcon, MusicIcon, CheckIcon }
